module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fill-in fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header clearfix text-left"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body"), _vm._v(" "), _c('div', {
    staticClass: "row m-t-10 sm-m-t-10"
  }, [_vm._t("footer")], 2)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "pg-close fs-14"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b46c418"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fill_modal.vue
// module id = 1236
// module chunks = 1